import { useEffect } from 'react';
import { useAnalytics } from 'ia-react-core';
import { Product } from 'omni-package-react-core';

const useListAnalytics = (products: Product[]) => {
  const { track } = useAnalytics();

  const ListAnalytics = useEffect(() => {
    if (!products) return;
    track({
      event: new MouseEvent('productsLoaded'),
      values:
      {
        productsNumber: products.length,
        products: products.map((p) => p.systemCode ?? p.ownerCode),
      },
    });
  }, [products, track]);

  return ListAnalytics;
};

export default useListAnalytics;
